import React from "react";
import AuthLayout from "./AuthLayout";
import { PasswordConfirmationFields, SubmitButton } from "./AuthFields";
import { LOGOUT_PATH, PRIVACY_URL } from "./constants";

const ChangePasswordPage = ({ action, lightTheme }) => (
  <AuthLayout
    action={action}
    method="put"
    formClassName="login-form"
    lightTheme={lightTheme}
    footer={
      <a href={PRIVACY_URL} className="privacy-policy no-decoration">
        Privacy Policy
      </a>
    }
  >
    <PasswordConfirmationFields
      passwordPlaceholder="Enter your new password"
      confirmationPlaceholder="Confirm your new password"
      autoFocus
    />

    <div className="mtm">
      <SubmitButton value="Save Password" />
    </div>

    <a href={LOGOUT_PATH} className="privacy-policy no-decoration">
      Logout
    </a>
  </AuthLayout>
);

export default ChangePasswordPage;
